import React from 'react';
import { Circle, G, Line, Path, Polygon, Rect, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { DT } from '../tokens';

/** η = WHP / BHP — pump curves (head, BHP, η%) with BEP marked. */
export function DiagramPumpEfficiency() {
  const ox = 50, oy = 200, w = 250, h = 160;

  return (
    <DiagramCanvas>
      {/* Axes */}
      <Line x1={ox} y1={oy} x2={ox + w} y2={oy} stroke={DT.dim} strokeWidth="1.4" />
      <Line x1={ox} y1={oy} x2={ox} y2={oy - h} stroke={DT.dim} strokeWidth="1.4" />
      {/* Right axis (η%) */}
      <Line x1={ox + w} y1={oy} x2={ox + w} y2={oy - h} stroke={DT.dim} strokeWidth="1.4" />

      <SvgText x={ox + w / 2} y={oy + 18} fill={DT.dim} fontSize="9" fontFamily={DT.mono} textAnchor="middle">GPM →</SvgText>
      <SvgText x={ox - 14} y={oy - h / 2} fill={DT.dim} fontSize="9" fontFamily={DT.mono} textAnchor="middle"
        rotation="-90" originX={ox - 14} originY={oy - h / 2}>Head (ft) ↑</SvgText>
      <SvgText x={ox + w + 12} y={oy - h / 2} fill={DT.varColor} fontSize="9" fontFamily={DT.mono} textAnchor="middle"
        rotation="90" originX={ox + w + 12} originY={oy - h / 2}>η % ↑</SvgText>

      {/* Head curve (descending) */}
      <Path d={`M${ox + 5},${oy - 130} Q${ox + 100},${oy - 110} ${ox + w - 10},${oy - 30}`}
        fill="none" stroke={DT.stroke} strokeWidth="2" />
      <SvgText x={ox + 30} y={oy - 138} fill={DT.stroke} fontSize="9" fontFamily={DT.mono}>Head</SvgText>

      {/* BHP curve (rising) */}
      <Path d={`M${ox + 5},${oy - 30} Q${ox + 100},${oy - 50} ${ox + w - 5},${oy - 100}`}
        fill="none" stroke={DT.leader} strokeWidth="1.5" strokeDasharray="5,3" />
      <SvgText x={ox + w - 30} y={oy - 90} fill={DT.leader} fontSize="9" fontFamily={DT.mono}>BHP</SvgText>

      {/* Efficiency curve (parabolic, peaks at BEP) */}
      <Path d={`M${ox + 5},${oy - 5} Q${ox + 130},${oy - h} ${ox + w - 5},${oy - 10}`}
        fill="none" stroke={DT.varColor} strokeWidth="2.2" />
      <SvgText x={ox + 130} y={oy - h - 6} fill={DT.varColor} fontSize="10" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">η%</SvgText>

      {/* BEP marker */}
      <Line x1={ox + 130} y1={oy - h + 4} x2={ox + 130} y2={oy} stroke={DT.dim} strokeWidth="0.7" strokeDasharray="2,2" />
      <Circle cx={ox + 130} cy={oy - h + 4} r={5} fill={DT.varColor} stroke={DT.stroke} strokeWidth="1.2" />
      <SvgText x={ox + 130} y={oy - h - 12} fill={DT.varColor} fontSize="9" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">BEP</SvgText>

      {/* Operating-point projection */}
      <Circle cx={ox + 165} cy={oy - 90} r={4} fill={DT.stroke} />
      <Line x1={ox + 165} y1={oy - 90} x2={ox} y2={oy - 90} stroke={DT.dim} strokeWidth="0.6" strokeDasharray="2,2" />
      <Line x1={ox + 165} y1={oy - 90} x2={ox + 165} y2={oy} stroke={DT.dim} strokeWidth="0.6" strokeDasharray="2,2" />

      {/* Labels */}
      <LeaderLine x1={ox + 165} y1={oy - 90} x2={20} y2={50} varName="op pt" desc="GPM, Head" anchor="start" />
      <LeaderLine x1={ox + 130} y1={oy - h + 4} x2={310} y2={50} varName="η_max" desc="best efficiency" anchor="end" />

      <FormulaTag formula="η_pump = WHP / BHP · 100%   (peaks at BEP)" />
    </DiagramCanvas>
  );
}
